$.jstree._themes = '/backend/css/jstree/';

function addRow(oTable, oRow) {
    oTable.tBodies[0].appendChild(oRow);
}

function createRow(id) {
    oTR = document.createElement("tr");
    oTR.id = id;
    return oTR;
}

function createCell(StrHTML) {
    oTD = document.createElement("td");
    oTD.appendChild(document.createTextNode(StrHTML));
    oTD.innerHTML = StrHTML;
    return oTD;
}

function addCell(oRow, oCell) {
    oRow.appendChild(oCell);
}

function killRow(oTbl, rowId) {
    oRow = document.getElementById(rowId);
    oTbl.removeChild(oRow);
}

function moveRowDown(CellId) {
    Row = document.getElementById(CellId);
    Row2 = Row.nextSibling;
    swapRows(Row, Row2);
}

function swapRows(rowOne, rowTwo) {
    sw1 = rowOne;
    t1 = sw1.cloneNode(true);
    sw2 = rowTwo;
    t2 = sw2.cloneNode(true);
    p1 = sw1.parentNode;
    p1.replaceChild(sw2, t1);
    p1.replaceChild(sw1, t2);
}

function emptyTBody(oTbl) {
    var ele = oTbl.tBodies[0].cloneNode(false);
    oTbl.replaceChild(ele, oTbl.tBodies[0]);
}

function emptytbody(tbd) {
    /*if (typeof document.getElementById == "function"){
        tbd = document.getElementById(Id);
    } else {
        eval ("tbd = document.all."+Id);
    }*/
    tbtr = tbd.getElementsByTagName("TR");

    for (tri = 0; tri < tbtr.length; tri++) {
        tbd.removeChild(tbtr[tri]);
    }
}

IE = document.all && !window.opera;
GK = window.sidebar;
AOB = [];
x = 0;

// function Fader() {
//     this.faktor = 1;
//     this.timeOut = false;
//     this.fade = function (x) {
//         clearTimeout(this.timeOut);
//         this.value = Number(eval('this.object.' + this.fattr)) + (this.delta * x);
//
//         if (this.value >= this.min && this.value <= this.max) {
//             eval('this.object.' + this.fattr + '=' + this.value);
//
//             this.timeOut = setTimeout('AOB[' + this.index + '].fade(' + x + ')', this.rate);
//             this.foready = 0;
//         } else {
//             if (parseFloat(document.getElementById("waitScreen").style.opacity) == 0)
//                 document.getElementById("waitScreen").style.display = OB.swit;
//         }
//     };
// }


// function init_fader(obj, delta, rate, min, max, swit) {
//     if (IE || GK) {
//         AOB.push(new Fader(x));
//         OB = AOB[x];
//         OB.index = x;
//         OB.object = obj;
//         OB.swit = swit;
//
//         if (IE) {
//             OB.fattr = 'filters.alpha.opacity';
//         } else {
//             OB.fattr = 'style.opacity';
//             OB.faktor = 100;
//         }
//
//         OB.delta = delta / OB.faktor;
//         OB.rate = rate;
//         OB.min = min / OB.faktor;
//         OB.max = max / OB.faktor;
//         OB.fadein = new Function('f1', 'AOB[' + x + '].fade(1)');
//         OB.fadeout = new Function('f2', 'AOB[' + x + '].fade(-1)');
//         OB.fade(1);
//         x++;
//     }
// }

maxval = 0;

function checkinputdate(oInput, StrDateValue) {
    return true;

    dumpPos = oInput.selectionStart;

    if (oInput.selectionStart > maxval) {
        maxval = oInput.selectionStart;
        //StrNewVal = oInputvalue.substr(0, oInput.selectionStart) + StrDateValue.substr(oInput.selectionStart, StrDateValue.length - oInput.selectionStart);
        //oInput.value = StrNewVal;
        //oInput.selectionStart = dumpPos;
    }

    ArrDT = oInput.value.split(" ");
    ArrD = ArrDT[0].split(".");
    ArrT = ArrDT[1].split(":");

    StrDd = ArrD[0];
    StrDm = ArrD[1];
    StrDa = ArrD[2];

    StrTh = ArrT[0];
    StrTm = ArrT[1];
    StrTs = ArrT[2];

    if ((parseInt(StrDd) > 31) && (dumpPos > 1)) {
        StrDd = '31';
    }

    if ((parseInt(StrDd) < 1) && (dumpPos > 1)) {
        StrDd = '01';
    }

    if ((StrDd.length == 1) && (dumpPos > 1)) {
        StrDd = '0' + StrDd;
    }

    if ((parseInt(StrDm) > 12) && (dumpPos > 4)) {
        StrDm = '12';
    }

    if ((parseInt(StrDm) < 1) && (dumpPos > 4)) {
        StrDm = '01';
    }

    if ((StrDm.length == 1) && (dumpPos > 4)) {
        StrDm = '0' + StrDm;
    }

    if ((parseInt(StrDa) > 2030) && (dumpPos > 9)) {
        StrDa = '2030';
    }

    if ((parseInt(StrDa) < 1900) && (dumpPos > 9)) {
        StrDa = '1900';
    }

    newVal = StrDd + "." + StrDm + "." + StrDa + " " + StrTh + ":" + StrTm + ":" + StrTs;
    oInput.value = newVal;
    oInput.selectionStart = dumpPos;
}

function set_browser(id, name, value) {
    document.getElementById(id).value = value;
    document.getElementById(id + "__tco").value = name;
}

function in_array(needle, haystack) {
    for (var m in haystack) {
        if (haystack[m] == needle) {
            return true;
        }
    }

    return false;
}

function array_remove_val(needle, haystack) {
    for (var m in haystack) {
        if (haystack[m] == needle) {
            haystack = haystack.slice(0, m).concat(haystack.slice(m + 1, haystack.length));
            return haystack;
        }
    }

    return false;
}

// deprecated
function float_select_set_xy(id, x, y) {
}

function float_select_toggle(id, ele) {
    oBox = $('#' + id);

    if (ele) {
        var pos = $(ele).position();
        oBox.css('left', pos.left + 25 + 'px');
        oBox.css('top', pos.top - 5 + 'px');
    }

    if ($(oBox).is(':hidden')) {
        $(oBox).show();
    } else {
        $(oBox).hide();
    }

    return false;
}

function StrReplace_e(strValue) {
    return strValue;
}

function AddOption_e(Name, Value, sel_table, Dom) {
    sel = false;

    if (sel_table == Value) {
        sel = true;
    } else {
        sel = false;
    }

    NewOpt = new Option(unescape(Name), Value, sel, sel);
    sel_len = Dom.length;
    Dom.options[sel_len] = NewOpt;
    Dom.options[sel_len].innerHTML = StrReplace_e(Name);

    Dom.value = "";

    if (sel == true) {
        selHT = sel_len;
    }
}

// Filter-Feld leeren
function emptyBox_e(Dom) {
    target = Dom.length;

    for (var j = 0; j < target; j++) {
        Dom.options[Dom.length - 1] = null;
    }
}